import { Box, Grid, TextField, Button, Typography } from '@mui/material';
import { supabase } from '../bd/supabase';
import { useState } from 'react';

const inputStyle = {
    '& .MuiFilledInput-root': {
        // Color estático: rgba(0,0,0,0.11)
        backgroundColor: 'rgba(0,0,0,0.11)',
        borderTopRightRadius: '20px',
        borderBottomRightRadius: '20px',
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
        fontSize: '14px',
        padding: '0 16px',
        color: 'white', // El color del texto sigue siendo blanco para contrastar con el fondo oscuro
        height: '42px',
        display: 'flex',
        alignItems: 'center',
        boxSizing: 'border-box',
        transition: 'background-color 0.3s ease', // Transición suave para el hover
        '&:hover': {
            // Color al hacer hover: Un gris mucho más claro o casi blanco
            backgroundColor: 'rgba(255,255,255,0.2)', // Blanco con 20% de opacidad, se verá más claro
            // O puedes usar un color sólido y más claro si prefieres:
            // backgroundColor: '#F0F0F0',
        },
    },
    '& .MuiFilledInput-input': {
        color: 'white', // Color del texto del input
        fontSize: '14px',
        padding: 0,
        height: '42px',
        display: 'flex',
        alignItems: 'center',
        lineHeight: '42px',
        boxSizing: 'border-box',
    },
    '& .MuiInputLabel-root': {
        color: '#ccc', // Color de la etiqueta
        fontSize: '14px',
        transform: 'translate(16px, 12px)',
    },
    '& .MuiInputLabel-shrink': {
        transform: 'translate(16px, -8px) scale(0.75)',
    },
};

export default function ContactForm() {
    const [formData, setFormData] = useState({
        nombre: '',
        telefono: '',
        correo: '',
        empresa: '',
        puesto: '',
        pais: '',
        estado: '',
        conociste: '',
        mensaje: '',
    });

    return (
        <Box
            sx={{
                width: '100%',
                maxWidth: { xs: '100%', md: '552px' },
                zIndex: 1,
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            <Typography
                variant="h4"
                sx={{
                    fontFamily: 'Poppins, sans-serif',
                    fontWeight: 600,
                    color: 'white',
                    mb: 1,
                    fontSize: { xs: '20px', sm: '26px', md: '32px' },
                }}
            >
                ¿Cómo podemos{' '}
                <Box
                    component="span"
                    sx={{
                        background: 'linear-gradient(90deg, #0A6274 0%, #13B8DA 100%)',
                        px: 1.5,
                        py: 0.5,
                        borderRadius: '30px',
                        color: 'white',
                        fontWeight: 600,
                        display: 'inline-block',
                    }}
                >
                    ayudarte?
                </Box>
            </Typography>

            <Typography
                sx={{
                    color: 'white',
                    fontWeight: 500,
                    mb: 3,
                    fontSize: { xs: '14px', sm: '16px' },
                }}
            >
                Llena el formulario y nos pondremos en contacto contigo muy pronto.
            </Typography>

            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        label="Nombre completo"
                        name="nombre"
                        value={formData.nombre}
                        onChange={(e) => setFormData({ ...formData, [e.target.name]: e.target.value })}
                        variant="filled"
                        InputProps={{ disableUnderline: true }}
                        sx={inputStyle}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        fullWidth
                        label="Teléfono"
                        name="telefono"
                        value={formData.telefono}
                        onChange={(e) => setFormData({ ...formData, [e.target.name]: e.target.value })}
                        variant="filled"
                        InputProps={{ disableUnderline: true }}
                        sx={inputStyle}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        fullWidth
                        label="Correo"
                        name="correo"
                        value={formData.correo}
                        onChange={(e) => setFormData({ ...formData, [e.target.name]: e.target.value })}
                        variant="filled"
                        InputProps={{ disableUnderline: true }}
                        sx={inputStyle}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        fullWidth
                        label="Empresa"
                        name="empresa"
                        value={formData.empresa}
                        onChange={(e) => setFormData({ ...formData, [e.target.name]: e.target.value })}
                        variant="filled"
                        InputProps={{ disableUnderline: true }}
                        sx={inputStyle}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        fullWidth
                        label="Puesto"
                        name="puesto"
                        value={formData.puesto}
                        onChange={(e) => setFormData({ ...formData, [e.target.name]: e.target.value })}
                        variant="filled"
                        InputProps={{ disableUnderline: true }}
                        sx={inputStyle}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        fullWidth
                        label="País"
                        name="pais"
                        value={formData.pais}
                        onChange={(e) => setFormData({ ...formData, [e.target.name]: e.target.value })}
                        variant="filled"
                        InputProps={{ disableUnderline: true }}
                        sx={inputStyle}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        fullWidth
                        label="Estado"
                        name="estado"
                        value={formData.estado}
                        onChange={(e) => setFormData({ ...formData, [e.target.name]: e.target.value })}
                        variant="filled"
                        InputProps={{ disableUnderline: true }}
                        sx={inputStyle}
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        label="¿Cómo nos conociste?"
                        name="conociste"
                        value={formData.conociste}
                        onChange={(e) => setFormData({ ...formData, [e.target.name]: e.target.value })}
                        variant="filled"
                        InputProps={{ disableUnderline: true }}
                        sx={inputStyle}
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        label="Mensaje o motivo de contacto"
                        name="mensaje"
                        value={formData.mensaje}
                        onChange={(e) => setFormData({ ...formData, [e.target.name]: e.target.value })}
                        multiline
                        variant="filled"
                        InputProps={{ disableUnderline: true }}
                        sx={{
                            '& .MuiFilledInput-root': {
                                ...inputStyle['& .MuiFilledInput-root'],
                                height: 'auto', 
                                '&:hover': {
                                    backgroundColor: 'rgba(255,255,255,0.2)', 
                                    
                                },
                            },
                            '& .MuiFilledInput-input': {
                                ...inputStyle['& .MuiFilledInput-input'], // Hereda los estilos base
                                height: 'auto', // Permite que el input se expanda
                                minHeight: '42px', // Asegura una altura mínima
                                alignItems: 'flex-start', // Alinea el texto al inicio
                                paddingTop: '12px', // Ajusta el padding superior para el label
                                paddingBottom: '12px', // Ajusta el padding inferior
                            },
                            '& .MuiInputLabel-root': {
                                ...inputStyle['& .MuiInputLabel-root'], // Hereda los estilos base
                            },
                            '& .MuiInputLabel-shrink': {
                                ...inputStyle['& .MuiInputLabel-shrink'], // Hereda los estilos base
                            },
                        }}
                    />
                </Grid>

                <Grid item xs={12}>
                    <Button
                        onClick={async () => {
                            try {
                                const { error } = await supabase
                                    .from('contactForm')
                                    .insert([{
                                        nombre: formData.nombre,
                                        apellido: '',
                                        empresa: formData.empresa,
                                        cargo: formData.puesto,
                                        telefono: formData.telefono,
                                        correo: formData.correo,
                                        mensaje: formData.mensaje,
                                    }]);

                                if (error) {
                                    console.error('❌ Error al guardar:', error.message);

                                    if (error.code === '23505') {
                                        alert('Este correo ya está registrado. Usa otro o revisa si ya enviaste una consulta.');
                                        return;
                                    }

                                    alert('Error al enviar el mensaje. Intenta de nuevo.');
                                    return;
                                }

                                alert('✅ Mensaje enviado correctamente.');
                                setFormData({
                                    nombre: '',
                                    telefono: '',
                                    correo: '',
                                    empresa: '',
                                    puesto: '',
                                    pais: '',
                                    estado: '',
                                    conociste: '',
                                    mensaje: '',
                                });
                            } catch (err) {
                                console.error('❌ Error inesperado:', err);
                            }
                        }}
                        variant="contained"
                        sx={{
                            background: 'linear-gradient(to right, #5BC7BD, #E0F7F6)',
                            color: '#004B50',
                            fontWeight: 'bold',
                            px: 4,
                            py: 1.5,
                            borderRadius: '20px',
                            textTransform: 'none',
                            mt: 2,
                            width: { xs: '100%', sm: 'auto' },
                            '&:hover': {
                                background: 'linear-gradient(to right, #48b0a9, #c5f0ec)',
                            },
                        }}
                    >
                        Enviar consulta
                    </Button>
                </Grid>
            </Grid>
        </Box>
    );
}